import { render } from "./subPTcal.vue?vue&type=template&id=3ccaf9b2&scoped=true"
import script from "./subPTcal.vue?vue&type=script&lang=js"
export * from "./subPTcal.vue?vue&type=script&lang=js"

import "./subPTcal.vue?vue&type=style&index=0&id=3ccaf9b2&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccaf9b2"]])

export default __exports__